import React from 'react';
import Feature from '../../components/Feature/Feature';
import './WhatGPT3.css';

const WhatGPT3 = () => (
  <div className="gpt3__whatgpt3 section__margin" id="wgpt3">
    <div className="gpt3__whatgpt3-feature">
      <Feature title="What is GPT-4" text="GPT-4 is the world's most powerful text generator. Because of its ability to provide accurate, fluent, and coherent output, AI is opening up new avenues for thinking about how to use AI to improve a lot of things. Here are some of the most intriguing options." />
    </div>
    <div className="gpt3__whatgpt3-heading">
      <h1 className="gradient__text">The possibilities are beyond your imagination</h1>
      <p>Explore the Library</p>
    </div>
    <div className="gpt3__whatgpt3-container">
      <Feature title="Chatbots" text="Chatbots are available to assist consumers 24 hours a day, seven days a week. Furthermore, they answer fast to all questions they get." />
      <Feature title="Knowledgebase" text="ChatGPT collects information from several sources to generate a unified body of text complete with bullet lists, sample code, and instructions on how to utilise it." />
      <Feature title="Education" text="GPT-4 can be used to solve many problems in the education sector. It can help improve education by improving the quality of teachers, students and content." />
    </div>
  </div>
);

export default WhatGPT3;